export default ScrollControll;

/** @ngInject */
function ScrollControll($location) {
  let vm = this;

  let position = {};

  vm.reset = () => position = {};
  vm.getPosition = () => position[$location.path()] || 0;
  vm.setPosition = (y) => position[$location.path()] = y;
}



/** WEBPACK FOOTER **
 ** ./common/decorators/scroll-control/scroll-control.service.ts
 **/